// utils/api.ts
export async function post(url: string, body: any) {
  const response = await fetch(url, {
    method: "POST",
    body: JSON.stringify(body),
    headers: {
      "Content-Type": "application/json",
    },
  });

  return response;
}

// New function for authenticated API calls
export async function postWithAuth(
  url: string,
  body: any,
  accessToken: string
) {
  const response = await fetch(url, {
    method: "POST",
    body: JSON.stringify(body),
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${accessToken}`,
    },
  });

  return response;
}

export function camelToSnakeCase(obj: any): any {
  if (typeof obj !== "object" || obj === null) {
    return obj;
  }

  // Handle Date objects by returning them as-is
  if (obj instanceof Date) {
    return obj;
  }

  if (Array.isArray(obj)) {
    return obj.map((item) => camelToSnakeCase(item));
  }

  return Object.entries(obj).reduce((acc, [key, value]) => {
    const newKey = key.replace(/([A-Z])/g, "_$1").toLowerCase();
    acc[newKey] = camelToSnakeCase(value);
    return acc;
  }, {} as any);
}

export function snakeToCamelCase(obj: any): any {
  if (typeof obj !== "object" || obj === null) {
    return obj;
  }

  // Handle Date objects by returning them as-is
  if (obj instanceof Date) {
    return obj;
  }

  if (Array.isArray(obj)) {
    return obj.map((item) => snakeToCamelCase(item));
  }

  return Object.entries(obj).reduce((acc, [key, value]) => {
    const newKey = key.replace(/_([a-z])/g, (g) => g[1].toUpperCase());
    acc[newKey] = snakeToCamelCase(value);
    return acc;
  }, {} as any);
}
